export const MAX_STROKE_WIDTH = 80;
export const MAX_TEXT_STROKE_WIDTH = 60;

export function maxStrokeWidth(tool: string): number {
  return tool === 'text' ? MAX_TEXT_STROKE_WIDTH : MAX_STROKE_WIDTH;
}
